import React, { useContext, useEffect, useLayoutEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { DetailsByUrl } from "./ReportsConstants";
import "./Reports.scss";
import DataTable from "../DataGrid/DataGrid";
import { ActiveAlarmsData } from "../Alarms/ActiveAlarms";
import { APP_BASE_URL_ALARM } from "../../Common/EndPoints";
import axios from "axios";
import EachStnChartComponent from "./COMPONENTS/LineChart";
import LineChart from "./COMPONENTS/LineChart";
import StackedBarChart from "./COMPONENTS/StackedBarChart";
import { useDispatch, useSelector } from "react-redux";
import {
  claerAllReportingFilters,
  selectCurrentReportFilters,
  selectGlobelReportFilter,
  selectReportFilter,
  selectTempReportFilter,
  updateTempFilterOnNavBack,
  updateTempReportFilters,
} from "./reportsSlice";
import { updateReportFilters } from "./reportsSlice";
import Filters from "./COMPONENTS/ReportFilters";
import ReportFilters from "./COMPONENTS/ReportFilters";
import NewReportsFilter from "./New Report filters/NewReportsFilter";
import { Box, Paper, Typography } from "@mui/material";
import {
  Assessment as ReportIcon,
  TableChart as TableIcon,
  BarChart as BarChartIcon,
  PieChart as PieChartIcon,
} from "@mui/icons-material";

function Reports() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const url = location.pathname;

  useEffect(() => {
    if (!Object.keys(DetailsByUrl).includes(url)) {
      navigate("/reports/failures-by-devices");
    }
  }, []);

  const globelReportsFilters = useSelector(selectGlobelReportFilter);
  const tempReportsFilter = useSelector(selectTempReportFilter);
  const currentReportFilters = useSelector(selectCurrentReportFilters);

  const { customerIdList } = useContext(ActiveAlarmsData);
  const [rawData, setRawData] = useState([]);

  // const [fullScreen, setFullScreen] = useState('')
  // const reportFilters = useSelector(selectReportFilter)
  useEffect(() => {
    // Define your callback function

    // Add the event listener when the component mounts
    window.addEventListener("popstate", handleBackNavigation);

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("popstate", handleBackNavigation);
    };
  }, []);

  useEffect(() => {
    if (customerIdList.length > 0) {
      let filterParams = {
        ...currentReportFilters,
        filterCustomerIds: currentReportFilters.filterCustomerIds
          .map((customer) => {
            return customer.customerId;
          })
          .toString(),
        device_type_ids: currentReportFilters.device_type_ids
          .map((geartype) => {
            return geartype.id;
          })
          .toString(),
        device_ids: currentReportFilters.device_ids
          .map((device) => {
            return device.id;
          })
          .toString(),
        categories: currentReportFilters.categories.toString(),
        alarm_types: currentReportFilters.alarm_types.toString(),
      };
      filterParams = {
        ...filterParams,
        software_ids: (filterParams?.software_ids || []).map((system) => system.systemId).toString(),
        customer_ids:
          filterParams.filterCustomerIds.length > 0 ? filterParams.filterCustomerIds : customerIdList.toString(),
      };
      fetchData(DetailsByUrl[url]?.getUrl, filterParams);
    }
  }, [url, currentReportFilters]);
  // useEffect(() => {
  //   if (customerIdList.length > 0) {
  //     let filterParams = { customer_ids: customerIdList.toString(), ...reportFilters }
  //     filterParams.device_type_ids = reportFilters.device_ids ? reportFilters.device_type_ids.map((value) => {
  //       return (value.id)
  //     }).toString() : null
  //     filterParams.categories = reportFilters.categories ? reportFilters.categories?.toString() : null
  //     filterParams.alarm_types = reportFilters.alarm_types ? reportFilters.alarm_types?.toString() : null
  //     filterParams.device_ids = reportFilters.device_ids ? reportFilters.device_ids.map((value) => {
  //       return (value.id)
  //     }).toString() : null
  //     fetchData(DetailsByUrl[url].getUrl, filterParams)
  //   }
  // }, [reportFilters])
  useEffect(() => {
    return () => {
      dispatch(claerAllReportingFilters());
    };
  }, []);
  function handleBackNavigation(event) {
    dispatch(updateTempFilterOnNavBack());
  }
  const fetchData = (fetchUrl, filterParams) => {
    setRawData([]);
    let url = `${APP_BASE_URL_ALARM}${fetchUrl}`;
    axios.get(url, { params: filterParams }).then((res) => {
      let RESPONSE = res.data;
      RESPONSE.forEach((row, i) => {
        row.id = i;
      });
      setRawData(RESPONSE);
    });
  };
  // let gidDesign = /reports/failures-by-devices
  // function clickFunction(){
  //     dispatch(updateReportFilters({b: 4214}))
  // }
  if (!Object.keys(DetailsByUrl).includes(url)) {
    // navigate('/users')
    return <></>;
  }
  return (
    <div className={`reports-container`}>
      {/* Page Header */}
      <Paper elevation={0} className="reports-header">
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box className="reports-header-icon">
            <ReportIcon />
          </Box>
          <Box>
            <Typography variant="h5" className="reports-title">
              {DetailsByUrl[url]?.name}
            </Typography>
            <Typography variant="body2" className="reports-subtitle">
              Analyze and export failure report data
            </Typography>
          </Box>
        </Box>
      </Paper>

      {/* Filters Section */}
      <Paper elevation={0} className="reports-filters-card">
        <NewReportsFilter />
      </Paper>

      {/* Data Table */}
      <Paper elevation={0} className="reports-card reports-table-card">
        <Box className="reports-card-header">
          <TableIcon sx={{ fontSize: 20, color: 'var(--primary-500)' }} />
          <Typography variant="subtitle1" className="reports-card-title">
            Report Data
          </Typography>
          <Typography variant="caption" className="reports-card-count">
            {rawData.length} records
          </Typography>
        </Box>
        <Box className="reports-table-container">
          <DataTable
            loading={false}
            tableInfo={{
              id: `reporting-table`,
              label: DetailsByUrl[url]?.name,
              requireAuthSign: false,
            }}
            rows={rawData}
            columns={DetailsByUrl[url]?.tableColumns}
          />
        </Box>
      </Paper>

      {/* Charts Section */}
      <Box className="reports-charts-grid">
        <Paper elevation={0} className="reports-card chart-card">
          <Box className="reports-card-header">
            <PieChartIcon sx={{ fontSize: 20, color: 'var(--primary-500)' }} />
            <Typography variant="subtitle1" className="reports-card-title">
              By Station
            </Typography>
          </Box>
          <Box className="chart-container">
            <LineChart dependsOn={"station"} data={rawData} dependsOnSignleData={DetailsByUrl[url]?.dependentOn} />
          </Box>
        </Paper>

        <Paper elevation={0} className="reports-card chart-card">
          <Box className="reports-card-header">
            <PieChartIcon sx={{ fontSize: 20, color: 'var(--primary-500)' }} />
            <Typography variant="subtitle1" className="reports-card-title">
              By {DetailsByUrl[url]?.dependentOn === 'category' ? 'Category' :
                  DetailsByUrl[url]?.dependentOn === 'alarm_type' ? 'Alarm Type' :
                  DetailsByUrl[url]?.dependentOn === 'gear_type' ? 'Asset Type' : 'Type'}
            </Typography>
          </Box>
          <Box className="chart-container">
            <LineChart dependsOn={DetailsByUrl[url]?.dependentOn} data={rawData} />
          </Box>
        </Paper>

        <Paper elevation={0} className="reports-card chart-card chart-card-wide">
          <Box className="reports-card-header">
            <BarChartIcon sx={{ fontSize: 20, color: 'var(--primary-500)' }} />
            <Typography variant="subtitle1" className="reports-card-title">
              Station vs Type Analysis
            </Typography>
          </Box>
          <Box className="chart-container">
            <StackedBarChart dependsOn={DetailsByUrl[url]?.dependentOn} response={rawData} />
          </Box>
        </Paper>
      </Box>
    </div>
  );
}

export default Reports;
